import { FormType } from '../../../form-types';
import { ZaludThroatPainQuestionFieldAnswers } from './questions';

const throatPain: FormType<ZaludThroatPainQuestionFieldAnswers> = {
  name: 'Throat Pain Intake',
  questions: [
    {
      key: 'zalud_throatPain_redFlagSymptoms',
      next: {
        condition: { 'zalud_throatPain_redFlagSymptoms.none': true },
        key: 'zalud_throatPain_fever',
        els: 'zalud_throatPain_ineligible'
      }
    },
    'zalud_throatPain_fever',
    'zalud_throatPain_strepTest',
    'zalud_throatPain_strepExposure',
    'zalud_throatPain_throatSymptoms',
    'zalud_throatPain_otherSymptoms',
    'zalud_throatPain_symptomDuration',
    'zalud_throatPain_additionalComments',
    {
      key: 'zalud_throatPain_consent',
      next: {
        condition: { 'zalud_throatPain_consent.proceed': true },
        key: 'zalud_throatPain_complete',
        els: 'zalud_throatPain_ineligible'
      }
    },
    'zalud_throatPain_complete',
    'zalud_throatPain_ineligible'
  ]
};

export default throatPain;
